import styles from './profile-photo.module.scss';

interface ProfilePhotoProps {
  user: any;
  radius?: string;
  fontSize?: string;
  fontWeight?: string;
  width?: string;
  height?: string;
  className?: string;
  onClick?: (e: React.MouseEvent<HTMLSpanElement, MouseEvent>) => void;
}

function ProfilePhoto({
  user,
  radius,
  fontSize,
  fontWeight,
  width = '2.5rem',
  height = '2.5rem',
  className,
  onClick,
}: ProfilePhotoProps) {
  const stringToColor = (string: any) => {
    let hash = 0;
    let i;

    for (i = 0; i < string.length; i += 1) {
      hash = string.charCodeAt(i) + ((hash << 5) - hash);
    }

    let color = '#';

    for (i = 0; i < 3; i += 1) {
      const value = (hash >> (i * 8)) & 0xff;
      color += `00${value.toString(16)}`.slice(-2);
    }

    return color;
  };

  const classes = `${styles.image} ${className || ''}`.trim();

  return (
    <div
      onClick={onClick}
      style={{
        backgroundColor: stringToColor(user?.username || ''),
        width: width,
        height: height,
        borderRadius: radius,
        fontSize: fontSize,
        fontWeight: fontWeight,
      }}
      className={classes}
    >
      {user && user.avatar ? (
        <img src={user?.avatar} alt={user.name} />
      ) : (
        <span>
          {(user?.username && user?.username.split(' ')[0]?.[0]) || ''}
          {(user?.username && user?.username.split(' ')[1]?.[0]) || ''}
        </span>
      )}
    </div>
  );
}

export default ProfilePhoto;
